import { restClient } from '@/Core'

import { LOGISTICIANS_FINANCIAL_REPORT_URL } from '../Contracts/ILogisticiansFinancialReport'
import { reportSearchParams, toNumber, toPeriod, toReportUser, toRows } from '../Helpers/reportResponse'

import type { ILogisticiansFinancialReport, LogisticiansFinancialSortField } from '../Contracts/ILogisticiansFinancialReport'
import type { IReportPeriod, IReportSort } from '../Contracts/IReportPeriod'

/**
 * «Звіт по логістам - фінансовий»: `GET /services/reports/logisticians_financial`
 * (`SPEC-027` §3.3). Сортує бек (білий список, ЗВ-03); «Разом» — теж бек
 * (ЗВ-08). Без GET-кешу: звіт має показувати свіжі цифри.
 */
export const LoadLogisticiansFinancialReportTask = async (
    period: IReportPeriod,
    sort: IReportSort<LogisticiansFinancialSortField> | null
): Promise<ILogisticiansFinancialReport> => {
    const response = (await restClient.get(
        LOGISTICIANS_FINANCIAL_REPORT_URL,
        { searchParams: reportSearchParams(period, sort) },
        { forceRefresh: true }
    )) as unknown as Record<string, unknown> | null

    const total = (response?.['total'] ?? {}) as Record<string, unknown>

    return {
        period: toPeriod(response?.['period'], period),
        rows: toRows(response?.['rows']).map((raw) => {
            const row = (raw ?? {}) as Record<string, unknown>

            return {
                user: toReportUser(row['user']),
                applications: toNumber(row['applications']),
                profit: toNumber(row['profit']),
                percentage: toNumber(row['percentage']),
            }
        }),
        total: {
            applications: toNumber(total['applications']),
            profit: toNumber(total['profit']),
            percentage: toNumber(total['percentage']),
        },
        companyProfit: toNumber(response?.['companyProfit']),
    }
}
